import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "product-attributes" };
import { computed } from 'vue';
import ProductUtils from "../services/ProductUtils";
import ProductAttributeGroup from "./ProductAttributeGroup.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAttributes',
    props: {
        product: {},
        variant: {},
        excludeGroups: {}
    },
    setup(__props) {
        const props = __props;
        const GROUP_GENERAL = {
            name: 'general',
            label: '',
            position: 0,
        };
        const attributeGroups = computed(() => {
            const groups = [];
            ProductUtils.mergeAttributes(props.product.master, props.variant)
                .map(a => a.group || GROUP_GENERAL)
                .filter(g => (props.excludeGroups ?? ['default']).indexOf(g.name) === -1)
                .forEach(group => {
                if (!groups.find(g => g.name === group.name)) {
                    groups.push(group);
                }
            });
            groups.sort((g1, g2) => {
                return g1.position - g2.position;
            });
            return groups;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: group.name,
                        class: "product-attributes__group"
                    }, [
                        _createVNode(ProductAttributeGroup, {
                            group: group.name,
                            product: __props.product,
                            variant: __props.variant
                        }, null, 8, ["group", "product", "variant"])
                    ]));
                }), 128))
            ]));
        };
    }
});
